/**
 * SuggestedLabels Component
 *
 * Displays AI-suggested labels as selectable pills during work item creation.
 * Labels show confidence scores and can be toggled for selection.
 */

import { Component, For } from "solid-js";
import type { LabelSuggestion } from "../../api";

export interface SuggestedLabelsProps {
  /** AI-suggested labels with confidence scores */
  labels: LabelSuggestion[];
  /** Currently selected label names */
  selected: Set<string>;
  /** Callback when a label is toggled */
  onToggle: (label: LabelSuggestion) => void;
}

export const SuggestedLabels: Component<SuggestedLabelsProps> = (props) => {
  return (
    <div>
      <div class="text-xs text-ink-3 mb-1.5">Suggested labels</div>
      <div class="flex flex-wrap gap-1.5">
        <For each={props.labels}>
          {(label) => {
            const isSelected = () => props.selected.has(label.name);
            const confidence = Math.round(label.confidence * 100);

            return (
              <button
                type="button"
                class={`
                  inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium
                  transition-colors cursor-pointer
                  ${
                    isSelected()
                      ? "bg-ink text-paper border border-ink"
                      : "bg-surface text-ink-2 border border-line hover:bg-sunken"
                  }
                `}
                style={
                  label.color
                    ? { "border-left": `3px solid ${label.color}` }
                    : {}
                }
                onClick={() => props.onToggle(label)}
                title={`${confidence}% confidence${label.existing_id ? " (existing label)" : ""}`}
              >
                {label.name}
                <span class="text-[10px] opacity-60">{confidence}%</span>
              </button>
            );
          }}
        </For>
      </div>
    </div>
  );
};
